import { Chip } from '@mui/material';
import type { EstadoPago, TramiteEstado } from '../types';

const ESTADO_TRAMITE: Record<TramiteEstado, { label: string; color: 'default' | 'info' | 'warning' | 'success' | 'error' }> = {
  recibido: { label: 'Recibido', color: 'default' },
  en_revision: { label: 'En revisión', color: 'info' },
  falta_informacion: { label: 'Falta información', color: 'warning' },
  resuelto: { label: 'Resuelto', color: 'success' },
  rechazado: { label: 'Rechazado', color: 'error' },
};

export function EstadoTramiteChip({ estado }: { estado: TramiteEstado }) {
  const e = ESTADO_TRAMITE[estado] ?? { label: estado, color: 'default' as const };
  return <Chip size="small" label={e.label} color={e.color} />;
}

const ESTADO_PAGO: Record<EstadoPago, { label: string; color: 'default' | 'warning' | 'success' | 'error' }> = {
  pagado: { label: 'Pagado', color: 'success' },
  pendiente: { label: 'Pendiente de pago', color: 'warning' },
  vencido: { label: 'Vencido', color: 'error' },
  parcial: { label: 'Pago parcial', color: 'warning' },
};

export function EstadoPagoChip({ estado }: { estado: EstadoPago }) {
  const e = ESTADO_PAGO[estado] ?? { label: estado, color: 'default' as const };
  return <Chip size="small" label={e.label} color={e.color} variant={estado === 'pagado' ? 'filled' : 'outlined'} />;
}
